import { useSelector } from 'react-redux';
import type { UserPreferencesData } from 'state/userPreferences';
import { getUserPreferenceData } from 'state/userPreferences/selectors';

/**
 * Hook that returns the user preferences present in the application state
 */
export const usePreferences = (): UserPreferencesData => useSelector(getUserPreferenceData);
